import React, { useEffect, useState } from "react";
import logo from "../../../asset/images/shubham_removebg.png";
import papadImg from "../../../asset/images/Lijjat.png";
import appConfig from "../../../config/appConfig";
import { AiFillProduct } from "react-icons/ai";
import { IoIosSend } from "react-icons/io";
import { FaBuilding, FaSlidersH, FaSave, FaCheckCircle, FaThumbsUp, FaHashtag, FaEdit, FaCoins, FaMobileAlt } from "react-icons/fa";
import { FaBox } from "react-icons/fa6";
import { FcDeleteDatabase } from "react-icons/fc";
import { MdReportProblem } from "react-icons/md";

const TagrosProductDisplayConfigPage = () => {
  const [companies, setCompanies] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const [selectedCompanyGrpId, setSelectedCompanyGrpId] = useState(null);
  const [displayConfig, setDisplayConfig] = useState(null);
  const [loading, setLoading] = useState(false);
  const [savingStatus, setSavingStatus] = useState("");
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [uploadingLogo, setUploadingLogo] = useState(false);

  // Dynamic Scan Status Thresholds State
  const [scanStatusConfigs, setScanStatusConfigs] = useState([
    { psc_statusid: 1, psc_statusname: "Original Product", psc_mincount: 0, psc_maxcount: 0, psc_displaytitle: "Original Product" },
    { psc_statusid: 2, psc_statusname: "Already Scanned", psc_mincount: 1, psc_maxcount: 5, psc_displaytitle: "Already Scanned" },
    { psc_statusid: 3, psc_statusname: "Duplicate", psc_mincount: 6, psc_maxcount: 999999, psc_displaytitle: "Duplicate" },
  ]);

  // Feedback form preview states
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);
  const [selectedFeedback, setSelectedFeedback] = useState("");
  const [feedbackText, setFeedbackText] = useState("");
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);

  // Generic Sample Placeholder Data
  const genericDummyProduct = {
    ProductName: "Sample Product Name",
    ProductCode: "PRD-1001",
    BatchName: "BATCH-001",
    MfgDate: "01-JAN-2026",
    ExpDate: "01-JAN-2027",
    ProductImage: papadImg,
  };

  const genericDummyPlantLocation = {
    lcm_locationname: "Sample Branch / Plant Name",
    mm_machinename: "Machine Line 01",
    lcm_locationstreet1: "123 Sample Industrial Area",
    lcm_city: "Sample City",
    lcm_state: "Sample State - 000000",
    lcm_country: "Country Name",
    lcm_contactnumber: "+91 0000000000",
    lcm_emailid: "contact@company.com",
  };

  const feedbackOptions = [
    { value: "Good Product Experience", label: "Good Product Experience", icon: <FaThumbsUp className="text-[#295a80]" /> },
    { value: "Packing Damaged", label: "Packing Damaged", icon: <FaBox className="text-2xl text-orange-500" /> },
    { value: "Product Data Mismatch", label: "Product Data Mismatch", icon: <FcDeleteDatabase className="text-2xl" /> },
    { value: "Product Quality Issue", label: "Product Quality Issue", icon: <MdReportProblem className="text-2xl text-purple-600" /> },
  ];

  useEffect(() => {
    fetchCompanies();
  }, []);

  useEffect(() => {
    if (selectedCompanyId !== null && selectedCompanyGrpId !== null) {
      fetchDisplayConfig(selectedCompanyId, selectedCompanyGrpId);
      fetchScanStatusConfig(selectedCompanyId, selectedCompanyGrpId);
    }
  }, [selectedCompanyId, selectedCompanyGrpId]);

  const fetchCompanies = async () => {
    try {
      const res = await fetch(`${appConfig.apiBaseUrl}/tagros/companies`);
      const result = await res.json();
      if (result.success && Array.isArray(result.data) && result.data.length > 0) {
        setCompanies(result.data);
        const match = result.data.find(
          (c) => Number(c.cm_id) === Number(selectedCompanyId) && Number(c.cm_companygrpid) === Number(selectedCompanyGrpId)
        );
        if (!match && result.data[0]) {
          setSelectedCompanyId(Number(result.data[0].cm_id));
          setSelectedCompanyGrpId(Number(result.data[0].cm_companygrpid));
        }
      } else {
        setCompanies([]);
        setSelectedCompanyId(null);
        setSelectedCompanyGrpId(null);
      }
    } catch (err) {
      console.error("Error fetching companies:", err);
      setCompanies([]);
      setSelectedCompanyId(null);
      setSelectedCompanyGrpId(null);
    }
  };

  const fetchDisplayConfig = async (companyId, companyGrpId) => {
    setLoading(true);
    setHasUnsavedChanges(false);
    try {
      const res = await fetch(
        `${appConfig.apiBaseUrl}/tagros/display-config?companyid=${companyId}&companygrpid=${companyGrpId}`
      );
      const result = await res.json();
      if (result.success && result.data) {
        setDisplayConfig(result.data);
      } else {
        setDisplayConfig(null);
      }
    } catch (err) {
      console.error("Error fetching display config:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchScanStatusConfig = async (companyId, companyGrpId) => {
    try {
      const res = await fetch(
        `${appConfig.apiBaseUrl}/tagros/scan-status-config?companyid=${companyId}&companygrpid=${companyGrpId}`
      );
      const result = await res.json();
      if (result.success && Array.isArray(result.data) && result.data.length > 0) {
        setScanStatusConfigs(result.data);
      } else {
        setScanStatusConfigs([
          { psc_statusid: 1, psc_statusname: "Original Product", psc_mincount: 0, psc_maxcount: 0, psc_displaytitle: "Original Product" },
          { psc_statusid: 2, psc_statusname: "Already Scanned", psc_mincount: 1, psc_maxcount: 5, psc_displaytitle: "Already Scanned" },
          { psc_statusid: 3, psc_statusname: "Duplicate", psc_mincount: 6, psc_maxcount: 999999, psc_displaytitle: "Duplicate" },
        ]);
      }
    } catch (err) {
      console.error("Error fetching scan status config:", err);
    }
  };

  const toggleSection = (sectionName, isVisible) => {
    setDisplayConfig((prev) => {
      const current = prev || {};
      const sec = current[sectionName] || { fields: {} };
      return {
        ...current,
        [sectionName]: {
          ...sec,
          visible: isVisible,
          title: sec.title || sectionName,
        },
      };
    });
    setHasUnsavedChanges(true);
  };

  const setSectionTitle = (sectionName, newTitle) => {
    setDisplayConfig((prev) => {
      const current = prev || {};
      const sec = current[sectionName] || { visible: true, fields: {} };
      return {
        ...current,
        [sectionName]: {
          ...sec,
          title: newTitle,
        },
      };
    });
    setHasUnsavedChanges(true);
  };

  const toggleField = (sectionName, fieldName, isVisible) => {
    setDisplayConfig((prev) => {
      const current = prev || {};
      const sec = current[sectionName] || { visible: true, fields: {} };
      const existing = sec.fields?.[fieldName];
      const existingTitle = typeof existing === 'object' ? (existing?.title || fieldName) : fieldName;

      return {
        ...current,
        [sectionName]: {
          ...sec,
          fields: {
            ...(sec.fields || {}),
            [fieldName]: {
              visible: isVisible,
              title: existingTitle,
            },
          },
        },
      };
    });
    setHasUnsavedChanges(true);
  };

  const setFieldTitle = (sectionName, fieldName, newTitle) => {
    setDisplayConfig((prev) => {
      const current = prev || {};
      const sec = current[sectionName] || { visible: true, fields: {} };
      const existing = sec.fields?.[fieldName];
      const existingVisible = typeof existing === 'object' ? existing?.visible !== false : existing !== false;

      return {
        ...current,
        [sectionName]: {
          ...sec,
          fields: {
            ...(sec.fields || {}),
            [fieldName]: {
              visible: existingVisible,
              title: newTitle,
            },
          },
        },
      };
    });
    setHasUnsavedChanges(true);
  };

  const updateScanStatusThreshold = (statusId, fieldKey, val) => {
    setScanStatusConfigs((prev) =>
      prev.map((item) =>
        item.psc_statusid === statusId
          ? { ...item, [fieldKey]: fieldKey === "psc_displaytitle" ? val : Number(val) }
          : item
      )
    );
    setHasUnsavedChanges(true);
  };

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!selectedCompanyId || !selectedCompanyGrpId) {
      alert("Please select a valid company first.");
      return;
    }

    const formData = new FormData();
    formData.append("logo", file);
    formData.append("companyid", selectedCompanyId);
    formData.append("companygrpid", selectedCompanyGrpId);

    setUploadingLogo(true);
    try {
      const res = await fetch(`${appConfig.apiBaseUrl}/tagros/upload-logo`, {
        method: "POST",
        body: formData
      });
      const result = await res.json();
      if (result.success && result.filename) {
        setDisplayConfig((prev) => {
          const current = prev || {};
          const logoSec = current["Company Logo"] || { visible: true, fields: {} };
          return {
            ...current,
            "Company Logo": {
              ...logoSec,
              companylogo: result.filename
            }
          };
        });
      } else {
        alert(result.error || "Failed to upload logo.");
      }
    } catch (err) {
      console.error("Error uploading logo:", err);
      alert("Error uploading logo to server.");
    } finally {
      setUploadingLogo(false);
    }
  };

  const saveAllConfiguration = async () => {
    if (!displayConfig) return;
    if (!selectedCompanyId || !selectedCompanyGrpId) {
      alert("Please select a valid company first.");
      return;
    }
    setSavingStatus("Saving...");
    try {
      // 1. Save Section & Field Display Configuration
      const resDisplay = await fetch(`${appConfig.apiBaseUrl}/tagros/save-all-display-config`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          companyid: selectedCompanyId,
          companygrpid: selectedCompanyGrpId,
          displayConfig: displayConfig,
        }),
      });
      const resultDisplay = await resDisplay.json();

      if (!resultDisplay.success) {
        alert(resultDisplay.error || "Failed to save display configuration.");
        setSavingStatus("");
        return;
      }

      // 2. Save Scan Status Threshold Configuration
      const resStatus = await fetch(`${appConfig.apiBaseUrl}/tagros/save-scan-status-config`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          companyid: selectedCompanyId,
          companygrpid: selectedCompanyGrpId,
          statusConfigs: scanStatusConfigs,
        }),
      });
      const resultStatus = await resStatus.json();

      if (resultStatus.success) {
        setSavingStatus("Saved Successfully!");
        setHasUnsavedChanges(false);
        setTimeout(() => setSavingStatus(""), 3000);
      } else {
        alert(resultStatus.error || "Failed to save scan status thresholds.");
        setSavingStatus("");
      }
    } catch (err) {
      console.error("Error saving configuration:", err);
      alert("Error saving configuration to database.");
      setSavingStatus("");
    }
  };

  const isSectionVisible = (sectionName) => {
    return displayConfig ? displayConfig[sectionName]?.visible !== false : true;
  };

  const getSectionTitle = (sectionName) => {
    return displayConfig?.[sectionName]?.title || sectionName;
  };

  const isFieldVisible = (sectionName, fieldName) => {
    const f = displayConfig?.[sectionName]?.fields?.[fieldName];
    if (typeof f === 'object' && f !== null) {
      return f.visible !== false;
    }
    return f !== false;
  };

  const getFieldTitle = (sectionName, fieldName) => {
    const f = displayConfig?.[sectionName]?.fields?.[fieldName];
    if (typeof f === 'object' && f !== null) {
      return f.title || fieldName;
    }
    return fieldName;
  };

  return (
    <div className="min-h-screen bg-gray-100 pb-16">
      {/* Sticky Header for Company Selection & Save Button */}
      <div className="sticky top-0 z-50 bg-[#295a80] px-4 py-3 text-white shadow-md border-b border-blue-900">
        <div className="mx-auto max-w-4xl flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-2">
            <h1 className="text-md md:text-lg font-bold">Company Configuration</h1>
          </div>

          <div className="flex items-center gap-3">
            {/* Company Selection Dropdown */}
            <div className="flex items-center gap-2 bg-white/10 px-3 py-1.5 rounded-lg border border-white/20">
              <FaBuilding className="text-blue-200" />
              <div className="flex flex-col">
                <label className="text-[10px] text-blue-200 font-semibold uppercase">Select Company:</label>
                <select
                  value={selectedCompanyId && selectedCompanyGrpId ? `${selectedCompanyId}_${selectedCompanyGrpId}` : ""}
                  onChange={(e) => {
                    if (!e.target.value) return;
                    if (hasUnsavedChanges && !window.confirm("You have unsaved changes! Discard and switch company?")) {
                      return;
                    }
                    const [cid, cgrpid] = e.target.value.split("_");
                    setSelectedCompanyId(Number(cid));
                    setSelectedCompanyGrpId(Number(cgrpid));
                    setShowFeedbackForm(false);
                    setFeedbackSubmitted(false);
                  }}
                  className="bg-transparent text-white font-bold outline-none cursor-pointer text-xs md:text-sm"
                >
                  {companies.length === 0 ? (
                    <option value="" disabled className="text-gray-900">
                      No Companies Found
                    </option>
                  ) : (
                    companies.map((comp) => (
                      <option
                        key={`${comp.cm_id}_${comp.cm_companygrpid}`}
                        value={`${comp.cm_id}_${comp.cm_companygrpid}`}
                        className="text-gray-900"
                      >
                        {comp.cm_companyname || `Company ${comp.cm_id} (Group ${comp.cm_companygrpid})`}
                      </option>
                    ))
                  )}
                </select>
              </div>
            </div>

            {/* Save Button */}
            <button
              onClick={saveAllConfiguration}
              className="flex items-center gap-2 px-4 py-2 rounded-lg font-bold text-xs md:text-sm bg-green-600 hover:bg-green-700 text-white shadow transition-all"
            >
              {savingStatus === "Saved Successfully!" ? <FaCheckCircle /> : <FaSave />}
              <span>{savingStatus || "SAVE"}</span>
            </button>
          </div>
        </div>
      </div>

      {/* Main Interactive Layout Container */}
      <div className="mx-auto max-w-lg md:max-w-2xl lg:max-w-3xl px-3 md:px-5 py-6">

        {/* SECTION 0A: COMPANY LOGO */}
        <div className="mb-6 rounded-xl border-2 border-dashed border-blue-400 bg-white p-4 shadow-md transition-all">
          <div className="flex items-center justify-between border-b pb-3 mb-3">
            <label className="flex items-center gap-2 font-bold text-[#295a80] cursor-pointer text-sm md:text-base">
              <input
                type="checkbox"
                checked={isSectionVisible("Company Logo")}
                onChange={(e) => toggleSection("Company Logo", e.target.checked)}
                className="h-5 w-5 rounded border-gray-300 text-[#295a80] focus:ring-[#295a80]"
              />
              Show "Company Logo" Header
            </label>
            <span className={`text-xs font-semibold px-2.5 py-0.5 rounded-full ${isSectionVisible("Company Logo") ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`}>
              {isSectionVisible("Company Logo") ? "Visible" : "Hidden"}
            </span>
          </div>

          {isSectionVisible("Company Logo") && (
            <div className="flex flex-col items-center gap-3">
              <div className="flex items-center justify-center border-2 border-gray-200 bg-white p-3 shadow-sm rounded-lg w-full max-w-xs">
                <img
                  src={displayConfig?.["Company Logo"]?.companylogo ? `${appConfig.apiBaseUrl.replace(/\/api\/?$/, "")}/public/companylogos/${displayConfig["Company Logo"].companylogo}` : logo}
                  alt="Company Logo"
                  className="h-10 sm:h-12 md:h-14 lg:h-16 w-auto object-contain"
                  style={{ maxWidth: "220px" }}
                />
              </div>
              <div className="flex flex-col items-center">
                <label className="cursor-pointer bg-[#295a80] text-white text-xs font-semibold px-3 py-1.5 rounded hover:bg-[#214c6d] transition">
                  {uploadingLogo ? "Uploading..." : "Upload Custom Logo"}
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleLogoUpload}
                    disabled={uploadingLogo}
                    className="hidden"
                  />
                </label>
                <p className="text-[10px] text-gray-500 mt-1">Recommended size: 220x80px. Max: 2MB</p>
              </div>
            </div>
          )}
        </div>

        {/* SECTION 0B: STATUS BANNER & SCAN THRESHOLD COUNTS */}
        <div className="mb-6 rounded-xl border-2 border-dashed border-blue-400 bg-white p-4 shadow-md transition-all">
          <div className="flex items-center justify-between border-b pb-3 mb-3">
            <label className="flex items-center gap-2 font-bold text-[#295a80] cursor-pointer text-sm md:text-base">
              <input
                type="checkbox"
                checked={isSectionVisible("Status Banner")}
                onChange={(e) => toggleSection("Status Banner", e.target.checked)}
                className="h-5 w-5 rounded border-gray-300 text-[#295a80] focus:ring-[#295a80]"
              />
              Show "Status Banner" (Already Scanned / Original)
            </label>
            <span className={`text-xs font-semibold px-2.5 py-0.5 rounded-full ${isSectionVisible("Status Banner") ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`}>
              {isSectionVisible("Status Banner") ? "Visible" : "Hidden"}
            </span>
          </div>

          {isSectionVisible("Status Banner") && (
            <div className="space-y-4">
              {/* Banner Visual Preview */}
              <div className="rounded-lg border border-yellow-500 bg-yellow-50 px-4 py-3 text-center text-yellow-700 font-semibold flex items-center justify-center gap-2 shadow-sm">
                <AiFillProduct /> {scanStatusConfigs.find(c => c.psc_statusid === 2)?.psc_displaytitle || scanStatusConfigs.find(c => c.psc_statusid === 2)?.psc_statusname || "Already Scanned"}
              </div>

              {/* Status Threshold Count Inputs Inside Status Banner Section */}
              <div className="mt-4 rounded-lg bg-gray-50 border border-gray-200 p-3.5">
                <p className="text-xs font-bold text-[#295a80] uppercase tracking-wider mb-3 flex items-center gap-1.5">
                  <FaHashtag /> SCAN COUNT STATUS THRESHOLDS CONFIG:
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                  {scanStatusConfigs.map((statusItem) => {
                    const isOriginal = statusItem.psc_statusid === 1;
                    const isAlready = statusItem.psc_statusid === 2;

                    const cardTheme = isOriginal
                      ? "border-green-300 bg-green-50/70"
                      : isAlready
                        ? "border-yellow-300 bg-yellow-50/70"
                        : "border-red-300 bg-red-50/70";

                    const badgeTheme = isOriginal
                      ? "bg-green-600 text-white"
                      : isAlready
                        ? "bg-yellow-600 text-white"
                        : "bg-red-600 text-white";

                    return (
                      <div key={statusItem.psc_statusid} className={`rounded-lg border p-2.5 ${cardTheme}`}>
                        <div className="flex items-center justify-between border-b pb-1.5 mb-2">
                          <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${badgeTheme}`}>
                            {statusItem.psc_statusname}
                          </span>
                        </div>
                        <div className="space-y-2 text-xs">
                          <div>
                            <label className="block font-bold text-gray-700 text-[10px]">Display Title:</label>
                            <input
                              type="text"
                              value={statusItem.psc_displaytitle || statusItem.psc_statusname}
                              onChange={(e) => updateScanStatusThreshold(statusItem.psc_statusid, "psc_displaytitle", e.target.value)}
                              className="w-full rounded border border-gray-300 p-1 font-bold text-gray-900 bg-white text-xs outline-none focus:border-[#295a80]"
                            />
                          </div>
                          <div>
                            <label className="block font-bold text-gray-700 text-[10px]">Min Count:</label>
                            <input
                              type="number"
                              min="0"
                              value={statusItem.psc_mincount}
                              onChange={(e) => updateScanStatusThreshold(statusItem.psc_statusid, "psc_mincount", e.target.value)}
                              className="w-full rounded border border-gray-300 p-1 font-bold text-gray-900 bg-white text-xs outline-none focus:border-[#295a80]"
                            />
                          </div>
                          <div>
                            <label className="block font-bold text-gray-700 text-[10px]">Max Count:</label>
                            <input
                              type="number"
                              min="0"
                              value={statusItem.psc_maxcount}
                              onChange={(e) => updateScanStatusThreshold(statusItem.psc_statusid, "psc_maxcount", e.target.value)}
                              className="w-full rounded border border-gray-300 p-1 font-bold text-gray-900 bg-white text-xs outline-none focus:border-[#295a80]"
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )}
        </div>

        {/* SECTION 0C: ROYALTY REWARDS SECTION */}
        <div className="mb-6 rounded-xl border-2 border-dashed border-amber-400 bg-white p-4 shadow-md transition-all">
          <div className="flex items-center justify-between border-b pb-3 mb-4">
            <label className="flex items-center gap-2 font-bold text-amber-900 cursor-pointer text-sm md:text-base">
              <input
                type="checkbox"
                checked={isSectionVisible("Royalty Rewards")}
                onChange={(e) => toggleSection("Royalty Rewards", e.target.checked)}
                className="h-5 w-5 rounded border-gray-300 text-amber-600 focus:ring-amber-500"
              />
              Show "Royalty Rewards" Section
            </label>
            <span className={`text-xs font-semibold px-2.5 py-0.5 rounded-full ${isSectionVisible("Royalty Rewards") ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`}>
              {isSectionVisible("Royalty Rewards") ? "Visible" : "Hidden"}
            </span>
          </div>

          {isSectionVisible("Royalty Rewards") && (
            <div className="space-y-3">
              {/* Editable Section Header Title */}
              <div className="flex items-center gap-2 rounded-lg bg-amber-50 border border-amber-300 p-2.5">
                <label className="text-xs font-bold text-amber-900 whitespace-nowrap">Section Title:</label>
                <input
                  type="text"
                  value={getSectionTitle("Royalty Rewards")}
                  onChange={(e) => setSectionTitle("Royalty Rewards", e.target.value)}
                  className="w-full rounded border border-amber-300 bg-white px-2 py-1 text-xs font-semibold text-gray-800 outline-none focus:border-amber-600"
                  placeholder="Royalty Rewards"
                />
                <FaEdit className="text-amber-700 text-xs flex-shrink-0" title="Edit Section Title" />
              </div>

              {/* Visual Card Preview */}
              <div className="overflow-hidden rounded-xl border border-amber-300 bg-gradient-to-br from-amber-50 via-yellow-50 to-amber-100/60 p-4 shadow-sm">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2.5">
                    <div className="flex h-9 w-9 items-center justify-center rounded-full bg-amber-500 text-white shadow">
                      <FaCoins className="text-lg" />
                    </div>
                    <div>
                      <h4 className="text-sm font-bold text-amber-900">
                        {getSectionTitle("Royalty Rewards") || "Royalty Rewards"}
                      </h4>
                      <span className="inline-block rounded-full bg-amber-200/80 px-2 py-0.5 text-[10px] font-semibold text-amber-800">
                        Active Scheme: Smart Rewards 2026
                      </span>
                    </div>
                  </div>
                  <div className="text-right">
                    <span className="text-[10px] font-semibold uppercase tracking-wider text-amber-700">Earned</span>
                    <div className="text-xl font-extrabold text-amber-700">+50 <span className="text-xs font-semibold">pts</span></div>
                  </div>
                </div>

                <div className="mt-3 border-t border-amber-200/70 pt-2.5">
                  <p className="text-[11px] text-amber-800 mb-2">
                    🎉 Congratulations! You received royalty points for scanning this original product.
                  </p>
                  <div className="flex gap-2">
                    <div className="relative flex-1">
                      <span className="absolute inset-y-0 left-0 flex items-center pl-2.5 text-[10px] font-semibold text-gray-500">+91</span>
                      <input
                        type="text"
                        disabled
                        placeholder="Enter 10-digit mobile number"
                        className="w-full rounded border border-amber-300 bg-white/80 py-1 pl-9 pr-2 text-xs text-gray-600 cursor-not-allowed"
                      />
                    </div>
                    <button
                      type="button"
                      disabled
                      className="flex items-center gap-1 rounded bg-amber-600 px-3 py-1 text-xs font-semibold text-white opacity-80 cursor-not-allowed"
                    >
                      <FaMobileAlt />
                      <span>Claim</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* SECTION 1: PRODUCT IMAGE SECTION */}
        <div className="mb-6 rounded-xl border-2 border-dashed border-blue-400 bg-white p-4 shadow-md transition-all">
          <div className="flex items-center justify-between border-b pb-3 mb-4">
            <label className="flex items-center gap-2 font-bold text-[#295a80] cursor-pointer text-sm md:text-base">
              <input
                type="checkbox"
                checked={isSectionVisible("Product Image")}
                onChange={(e) => toggleSection("Product Image", e.target.checked)}
                className="h-5 w-5 rounded border-gray-300 text-[#295a80] focus:ring-[#295a80]"
              />
              Show "Product Image" Section
            </label>
            <span className={`text-xs font-semibold px-2.5 py-0.5 rounded-full ${isSectionVisible("Product Image") ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`}>
              {isSectionVisible("Product Image") ? "Visible" : "Hidden"}
            </span>
          </div>

          {isSectionVisible("Product Image") && (
            <div className="flex justify-center py-2">
              <img
                src={genericDummyProduct.ProductImage}
                alt={genericDummyProduct.ProductName}
                className="h-56 w-56 rounded-lg border object-contain shadow bg-white p-2"
              />
            </div>
          )}
        </div>

        {/* SECTION 2: PRODUCT DETAILS SECTION */}
        <div className="mb-6 rounded-xl border-2 border-dashed border-blue-400 bg-white p-4 shadow-md transition-all">
          <div className="flex items-center justify-between border-b pb-3 mb-4">
            <label className="flex items-center gap-2 font-bold text-[#295a80] cursor-pointer text-sm md:text-base">
              <input
                type="checkbox"
                checked={isSectionVisible("Product Details")}
                onChange={(e) => toggleSection("Product Details", e.target.checked)}
                className="h-5 w-5 rounded border-gray-300 text-[#295a80] focus:ring-[#295a80]"
              />
              Show "Product Details" Section
            </label>
            <span className={`text-xs font-semibold px-2.5 py-0.5 rounded-full ${isSectionVisible("Product Details") ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`}>
              {isSectionVisible("Product Details") ? "Visible" : "Hidden"}
            </span>
          </div>

          {isSectionVisible("Product Details") && (
            <div className="overflow-hidden border-2 border-gray-400 bg-white shadow-sm rounded-lg">
              {/* Editable Section Header Title */}
              <div className="border-b-2 border-gray-400 bg-[#295a80] px-4 py-3 flex items-center justify-center gap-2">
                <input
                  type="text"
                  value={getSectionTitle("Product Details")}
                  onChange={(e) => setSectionTitle("Product Details", e.target.value)}
                  className="bg-transparent border-b border-white/60 text-white font-semibold text-center outline-none focus:border-white px-2 py-0.5 text-md md:text-lg w-full max-w-md"
                  placeholder="Product Details Header Title"
                />
                <FaEdit className="text-blue-200 text-xs flex-shrink-0" title="Edit Section Title" />
              </div>

              {/* Interactive Rows */}
              <div className="flex flex-col">
                {[
                  ["Product Name", genericDummyProduct.ProductName],
                  ["Product Code", genericDummyProduct.ProductCode],
                  ["Batch Name", genericDummyProduct.BatchName],
                  ["Mfg Date", genericDummyProduct.MfgDate],
                  ["Exp Date", genericDummyProduct.ExpDate],
                ].map(([fieldName, fieldValue], index) => {
                  const checked = isFieldVisible("Product Details", fieldName);
                  const displayTitle = getFieldTitle("Product Details", fieldName);
                  return (
                    <div
                      key={fieldName}
                      className={`flex border-b border-gray-300 last:border-b-0 transition ${checked ? (index % 2 === 0 ? "bg-gray-50" : "bg-white") : "bg-red-50/50 opacity-60"
                        }`}
                    >
                      <div className="flex w-[48%] items-center gap-2 border-r border-gray-300 px-3 py-2 text-xs sm:text-sm font-bold text-[#295a80]">
                        <input
                          type="checkbox"
                          checked={checked}
                          onChange={(e) => toggleField("Product Details", fieldName, e.target.checked)}
                          className="h-4 w-4 rounded border-gray-300 text-[#295a80] focus:ring-[#295a80]"
                        />
                        <input
                          type="text"
                          value={displayTitle}
                          onChange={(e) => setFieldTitle("Product Details", fieldName, e.target.value)}
                          className="bg-transparent border-b border-gray-300 focus:border-[#295a80] outline-none text-xs sm:text-sm font-bold text-[#295a80] w-full px-1 py-0.5"
                          placeholder={fieldName}
                        />
                      </div>
                      <div className="flex w-[52%] items-center px-3 py-2 text-xs sm:text-sm font-medium text-gray-800">
                        {checked ? fieldValue : <span className="text-xs text-red-500 italic">(Hidden)</span>}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>

        {/* SECTION 3: MANUFACTURING DETAILS SECTION */}
        <div className="mb-6 rounded-xl border-2 border-dashed border-blue-400 bg-white p-4 shadow-md transition-all">
          <div className="flex items-center justify-between border-b pb-3 mb-4">
            <label className="flex items-center gap-2 font-bold text-[#295a80] cursor-pointer text-sm md:text-base">
              <input
                type="checkbox"
                checked={isSectionVisible("Manufacturing Details")}
                onChange={(e) => toggleSection("Manufacturing Details", e.target.checked)}
                className="h-5 w-5 rounded border-gray-300 text-[#295a80] focus:ring-[#295a80]"
              />
              Show "Manufacturing Details" Section
            </label>
            <span className={`text-xs font-semibold px-2.5 py-0.5 rounded-full ${isSectionVisible("Manufacturing Details") ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`}>
              {isSectionVisible("Manufacturing Details") ? "Visible" : "Hidden"}
            </span>
          </div>

          {isSectionVisible("Manufacturing Details") && (
            <div className="overflow-hidden border-2 border-gray-400 bg-white shadow-sm rounded-lg">
              {/* Editable Section Header Title */}
              <div className="border-b-2 border-gray-400 bg-[#295a80] px-4 py-3 flex items-center justify-center gap-2">
                <input
                  type="text"
                  value={getSectionTitle("Manufacturing Details")}
                  onChange={(e) => setSectionTitle("Manufacturing Details", e.target.value)}
                  className="bg-transparent border-b border-white/60 text-white font-semibold text-center outline-none focus:border-white px-2 py-0.5 text-md md:text-lg w-full max-w-md"
                  placeholder="Manufacturing Details Header Title"
                />
                <FaEdit className="text-blue-200 text-xs flex-shrink-0" title="Edit Section Title" />
              </div>

              {/* Interactive Rows */}
              <div className="flex flex-col">
                {[
                  ["Branch Name", genericDummyPlantLocation.lcm_locationname],
                  ["Machine Name", genericDummyPlantLocation.mm_machinename],
                  [
                    "Address",
                    `${genericDummyPlantLocation.lcm_locationstreet1}, ${genericDummyPlantLocation.lcm_city}, ${genericDummyPlantLocation.lcm_state}`,
                  ],
                  ["Contact Number", genericDummyPlantLocation.lcm_contactnumber],
                  ["Email", genericDummyPlantLocation.lcm_emailid],
                ].map(([fieldName, fieldValue], index) => {
                  const checked = isFieldVisible("Manufacturing Details", fieldName);
                  const displayTitle = getFieldTitle("Manufacturing Details", fieldName);
                  return (
                    <div
                      key={fieldName}
                      className={`flex border-b border-gray-300 last:border-b-0 transition ${checked ? (index % 2 === 0 ? "bg-gray-50" : "bg-white") : "bg-red-50/50 opacity-60"
                        }`}
                    >
                      <div className="flex w-[48%] items-center gap-2 border-r border-gray-300 px-3 py-2 text-xs sm:text-sm font-bold text-[#295a80]">
                        <input
                          type="checkbox"
                          checked={checked}
                          onChange={(e) => toggleField("Manufacturing Details", fieldName, e.target.checked)}
                          className="h-4 w-4 rounded border-gray-300 text-[#295a80] focus:ring-[#295a80]"
                        />
                        <input
                          type="text"
                          value={displayTitle}
                          onChange={(e) => setFieldTitle("Manufacturing Details", fieldName, e.target.value)}
                          className="bg-transparent border-b border-gray-300 focus:border-[#295a80] outline-none text-xs sm:text-sm font-bold text-[#295a80] w-full px-1 py-0.5"
                          placeholder={fieldName}
                        />
                      </div>
                      <div className="flex w-[52%] items-center justify-start text-left px-3 py-2 text-xs sm:text-sm font-medium text-gray-800">
                        {checked ? fieldValue : <span className="text-xs text-red-500 italic">(Hidden)</span>}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>

        {/* SECTION 4: SEND FEEDBACK BUTTON & FORM */}
        <div className="mb-6 rounded-xl border-2 border-dashed border-blue-400 bg-white p-4 shadow-md transition-all">
          <div className="flex items-center justify-between border-b pb-3 mb-4">
            <label className="flex items-center gap-2 font-bold text-[#295a80] cursor-pointer text-sm md:text-base">
              <input
                type="checkbox"
                checked={isSectionVisible("Send Feedback")}
                onChange={(e) => toggleSection("Send Feedback", e.target.checked)}
                className="h-5 w-5 rounded border-gray-300 text-[#295a80] focus:ring-[#295a80]"
              />
              Show "SEND FEEDBACK" Section
            </label>
            <span className={`text-xs font-semibold px-2.5 py-0.5 rounded-full ${isSectionVisible("Send Feedback") ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`}>
              {isSectionVisible("Send Feedback") ? "Visible" : "Hidden"}
            </span>
          </div>

          {isSectionVisible("Send Feedback") && (
            <div className="space-y-6">
              {/* Configuration Table for Feedback Options */}
              <div className="overflow-hidden border-2 border-gray-400 bg-white shadow-sm rounded-lg">
                {/* Editable Section Header Title */}
                <div className="border-b-2 border-gray-400 bg-[#295a80] px-4 py-3 flex items-center justify-center gap-2">
                  <input
                    type="text"
                    value={getSectionTitle("Send Feedback")}
                    onChange={(e) => setSectionTitle("Send Feedback", e.target.value)}
                    className="bg-transparent border-b border-white/60 text-white font-semibold text-center outline-none focus:border-white px-2 py-0.5 text-md md:text-lg w-full max-w-md"
                    placeholder="Send Feedback Header Title"
                  />
                  <FaEdit className="text-blue-200 text-xs flex-shrink-0" title="Edit Section Title" />
                </div>

                {/* Interactive Rows for Feedback Options */}
                <div className="flex flex-col">
                  {feedbackOptions.map((opt, index) => {
                    const checked = isFieldVisible("Send Feedback", opt.value);
                    const displayTitle = getFieldTitle("Send Feedback", opt.value) || opt.label;
                    return (
                      <div
                        key={opt.value}
                        className={`flex border-b border-gray-300 last:border-b-0 transition ${checked ? (index % 2 === 0 ? "bg-gray-50" : "bg-white") : "bg-red-50/50 opacity-60"
                          }`}
                      >
                        <div className="flex w-[48%] items-center gap-2 border-r border-gray-300 px-3 py-2 text-xs sm:text-sm font-bold text-[#295a80]">
                          <input
                            type="checkbox"
                            checked={checked}
                            onChange={(e) => toggleField("Send Feedback", opt.value, e.target.checked)}
                            className="h-4 w-4 rounded border-gray-300 text-[#295a80] focus:ring-[#295a80]"
                          />
                          <input
                            type="text"
                            value={displayTitle}
                            onChange={(e) => setFieldTitle("Send Feedback", opt.value, e.target.value)}
                            className="bg-transparent border-b border-gray-300 focus:border-[#295a80] outline-none text-xs sm:text-sm font-bold text-[#295a80] w-full px-1 py-0.5"
                            placeholder={opt.label}
                          />
                        </div>
                        <div className="flex w-[52%] items-center justify-start text-left px-3 py-2 text-xs sm:text-sm font-medium text-gray-800 gap-2">
                          <div className="flex h-6 w-6 items-center justify-center rounded-full bg-gray-100">
                            {opt.icon}
                          </div>
                          <span>{checked ? displayTitle : <span className="text-xs text-red-500 italic">(Hidden)</span>}</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Feedback Form Preview Container */}
              <div className="rounded-xl border bg-white p-4 shadow">
                {!showFeedbackForm && !feedbackSubmitted && (
                  <button
                    onClick={() => setShowFeedbackForm(true)}
                    className="flex w-full items-center justify-center gap-2 rounded-lg bg-[#295a80] py-3 font-semibold text-white transition hover:bg-[#214c6d]"
                  >
                    <IoIosSend className="text-xl" /> SEND FEEDBACK (PREVIEW)
                  </button>
                )}

                {showFeedbackForm && !feedbackSubmitted && (
                  <>
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-lg font-semibold text-[#295a80]">
                        {getSectionTitle("Send Feedback")} Preview
                      </h3>
                      <button
                        onClick={() => setShowFeedbackForm(false)}
                        className="text-xs text-gray-500 hover:text-gray-700 underline"
                      >
                        Close Form
                      </button>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                      {feedbackOptions
                        .filter((opt) => isFieldVisible("Send Feedback", opt.value))
                        .map((item) => {
                          const displayTitle = getFieldTitle("Send Feedback", item.value) || item.label;
                          return (
                            <div
                              key={item.value}
                              onClick={() => setSelectedFeedback(item.value)}
                              className={`relative cursor-pointer rounded-xl border p-3 text-center transition-all duration-300 ${selectedFeedback === item.value
                                ? "border-green-500 bg-green-50 shadow"
                                : "border-gray-200 hover:border-green-300"
                                }`}
                            >
                              <div
                                className={`absolute right-3 top-3 flex h-5 w-5 items-center justify-center rounded-full border-2 ${selectedFeedback === item.value ? "border-green-600" : "border-gray-400"
                                  }`}
                              >
                                {selectedFeedback === item.value && (
                                  <div className="h-1.5 w-1.5 rounded-full bg-green-600"></div>
                                )}
                              </div>
                              <div className="mx-auto mb-2 flex h-10 w-10 items-center justify-center rounded-full bg-gray-100">
                                {item.icon}
                              </div>
                              <p className="text-xs font-semibold text-[#295a80]">{displayTitle}</p>
                            </div>
                          );
                        })}
                    </div>

                    <div className="mt-4">
                      <label className="mb-1 block text-sm font-semibold text-[#295a80]">
                        Additional Feedback
                      </label>
                      <textarea
                        rows={3}
                        value={feedbackText}
                        onChange={(e) => setFeedbackText(e.target.value)}
                        placeholder="Write your feedback here..."
                        className="w-full rounded-lg border border-gray-300 p-2.5 outline-none focus:border-[#295a80] text-sm"
                      />
                    </div>

                    <button
                      onClick={() => setFeedbackSubmitted(true)}
                      disabled={!selectedFeedback}
                      className="mt-4 flex w-full items-center justify-center gap-2 rounded-lg bg-[#295a80] py-3 font-semibold text-white transition hover:bg-[#214c6d] disabled:bg-gray-400"
                    >
                      <IoIosSend className="text-xl" /> SUBMIT FEEDBACK
                    </button>
                  </>
                )}

                {feedbackSubmitted && (
                  <div className="rounded-xl border border-green-100 bg-green-50 p-4">
                    <div className="flex items-center gap-3">
                      <FaCheckCircle className="text-3xl text-green-600" />
                      <div>
                        <h4 className="text-sm font-bold text-green-700">Feedback Demo Submitted!</h4>
                        <p className="text-xs text-gray-600 mt-0.5">
                          This shows how user feedback submission will appear.
                        </p>
                      </div>
                    </div>
                    <button
                      onClick={() => {
                        setFeedbackSubmitted(false);
                        setShowFeedbackForm(false);
                        setSelectedFeedback("");
                      }}
                      className="mt-3 text-xs text-[#295a80] underline font-semibold"
                    >
                      Reset Feedback Form Preview
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default TagrosProductDisplayConfigPage;

